"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
var _projectType = require("@/api/project/projectType");
var _project = require("@/api/project/project");
var _public = require("@/api/public/public");
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FileUpload: _fileUpload.default
  },
  data: function data() {
    return {
      // 作品清单
      workList: [{
        name: "",
        endTime: "",
        startTime: ""
      }],
      // 添加材料的列表
      mateList: [{
        id: new Date().getTime() + "",
        materialName: "",
        endTime: "",
        startTime: ""
      }],
      list: [],
      yearList: [{
        name: "2021",
        value: "2021"
      }, {
        name: "2022",
        value: "2022"
      }, {
        name: "2023",
        value: "2023"
      }, {
        name: "2024",
        value: "2024"
      }, {
        name: "2025",
        value: "2025"
      }, {
        name: "2026",
        value: "2026"
      }, {
        name: "2027",
        value: "2027"
      }, {
        name: "2028",
        value: "2028"
      }, {
        name: "2029",
        value: "2029"
      }, {
        name: "2030",
        value: "2030"
      }],
      typeList: [{
        keyData: "中职",
        valueData: "1"
      }, {
        keyData: "高职",
        valueData: "2"
      }, {
        keyData: "本科",
        valueData: "3"
      }],
      // typeList: [
      //   {
      //     label: "中职",
      //     value: "1"
      //   },
      //   {
      //     label: "高职",
      //     value: "2"
      //   },
      //   {
      //     label: "本科",
      //     value: "3"
      //   }
      // ],
      form: {
        matchName: "",
        //项目名称
        matchType: "",
        //项目类型
        matchYear: "",
        //项目年份
        // checkList: ["教育局"], //项目
        isNeedForm: 0,
        //是否需要报名表
        isNeedCheckForm: 1,
        //
        materialListParamList: "",
        //材料设置
        matchWorkFormRuleList: "",
        //作品清单
        endTime: "",
        //结束时间
        schoolType: "",
        //参与比赛院校类型
        startTime: "",
        // 开始时间
        sort: 0,
        //排序
        id: "",
        //序号
        agreement: "",
        //专家承诺书
        formProcessId: "",
        //报名表所属流程
        remake: ""
      },
      rules: {
        matchName: [{
          required: true,
          message: "请输入项目名称。",
          trigger: "blur"
        }],
        matchType: [{
          required: true,
          message: "请输入项目类型。",
          trigger: "change"
        }],
        matchYear: [{
          required: true,
          message: "请输入项目年份。",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    getUploadFileData: function getUploadFileData(data) {
      if (data.code === 1) {
        this.form.agreement = data.ossOriUrl;
        this.$message.success("上传成功。");
      }
    },
    // 添加作品清单
    addWorks: function addWorks() {
      this.workList.push({
        name: "",
        endTime: "",
        startTime: ""
      });
    },
    // 删除作品清单
    removeWorks: function removeWorks(index) {
      this.workList.splice(index, 1);
    },
    // 获取项目级别下拉列表
    getTypeList: function getTypeList() {
      var _this = this;
      (0, _public.selectList)({
        businessTypeId: "3"
      }).then(function (res) {
        _this.typeList = res.data;
      });
    },
    // 添加材料
    addMajor: function addMajor() {
      this.mateList.push({
        name: "",
        id: ""
      });
    },
    // 删除材料
    removeMajor: function removeMajor(index) {
      this.mateList.splice(index, 1);
    },
    // 提交
    submit: function submit(v) {
      var _this2 = this;
      console.log(this.workList, "ws");
      this.form.schoolType = this.form.schoolType.toString();
      this.$refs[v].validate(function (valid) {
        if (valid) {
          _this2.form.materialListParamList = _this2.mateList;
          _this2.form.matchWorkFormRuleList = _this2.workList;
          (0, _project.projectEdit)(_this2.form).then(function (res) {
            if (res.code === 2000) {
              _this2.$message.success("操作成功。");
              _this2.$router.push("/object/object");
            }
          });
        }
      });
    },
    // 返回
    isBack: function isBack() {
      this.$router.push("/object/object");
    },
    // 根据id回显数据
    viewById: function viewById() {
      var _this3 = this;
      (0, _project.backView)({
        id: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        _this3.form = data;
        if (data.schoolType) {
          _this3.form.schoolType = data.schoolType.split(",");
        } else {
          _this3.form.schoolType = [];
        }
        if (data.materialRuleList.length > 0) {
          _this3.mateList = data.materialRuleList;
        }
        if (data.workFormRuleList.length > 0) {
          _this3.workList = data.workFormRuleList;
        }
      });
    }
  },
  created: function created() {
    var _this4 = this;
    // 获取项目级别类别
    this.getTypeList();
    this.viewById();
    // 项目类型列表
    (0, _projectType.projectTypeListAll)().then(function (res) {
      var data = res.data;
      _this4.list = data.list;
    });
  }
};